export default class PortalModal {

    constructor() {
        this.settings = {
            toggles: document.querySelectorAll('.js-portal-modal-toggle'),
            closeBtn: document.querySelector('.js-modal-close'),
        };

        this.bindUIActions();
    }

    bindUIActions() {
        this.settings.toggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                const modal = document.querySelector('.js-portal-modal');
                modal.classList.toggle('hidden');
                document.body.classList.toggle('overflow-hidden');
            });
        });

        if (this.settings.closeBtn != null) {
            this.settings.closeBtn.addEventListener('click', () => {
                const modal = document.querySelector('.js-portal-modal');
                modal.classList.add('hidden');
                document.body.classList.remove('overflow-hidden');
            });
        }
    }
};

new PortalModal();